import cn from 'classnames';
import { format } from 'date-fns';
import ru from 'date-fns/locale/ru';
import React from 'react';
import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { ActionButton } from '@src/components/item/ActionButton';
import { emptyArray } from '@src/helpers/emptyArray';
import { formatMoney } from '@src/helpers/formatMoney';
import { selectItemSource } from '@src/reducers/product';

import { getReturnCondition } from '../utils';

import styles from './styles.module.scss';

export const Condition = () => {
    const { rates: { RUB: rates = emptyArray } = {} } = useSelector(selectItemSource) ?? {};
    const {
        values: { amount, term },
    } = useFormState();

    // eslint-disable-next-line @typescript-eslint/init-declarations
    let returnCondition;
    {
        const condition = getReturnCondition(rates, amount, term);
        const validReturnCondition = React.useRef(condition);
        if (condition === undefined) {
            returnCondition = validReturnCondition.current;
        } else {
            returnCondition = condition;
            validReturnCondition.current = condition;
        }
    }
    if (returnCondition === undefined) {
        return null;
    }
    const { rate, returnTerm, returnAmount } = returnCondition;
    return (
        <div className={styles.container}>
            <div className={styles.item}>
                <div className={styles.name}>Сумма к возврату</div>
                <div className={styles.value}>{formatMoney(returnAmount)}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.name}>В срок до</div>
                <div className={cn(styles.value, styles.value_green)}>
                    {format(returnTerm, 'd MMMM', { locale: ru })}
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.name}>Ставка</div>
                <div className={styles.value}>{`от ${rate}%`}</div>
            </div>
            <ActionButton />
        </div>
    );
};
